
import { useState, useCallback } from "react"
import { Check, Copy } from "lucide-react"
import { cn } from "@/lib/utils"

interface CopyableTextProps {
  text: string
  displayText?: string
  className?: string
  mono?: boolean
}

export function CopyableText({
  text,
  displayText,
  className,
  mono = true,
}: CopyableTextProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation()
      navigator.clipboard.writeText(text).then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
      })
    },
    [text]
  )

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={`Copiar: ${text}`}
      className={cn(
        "group inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-left transition-colors",
        "hover:bg-muted/80 active:bg-muted",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
        mono && "font-mono",
        className
      )}
    >
      <span className="break-all text-xs leading-relaxed">
        {displayText || text}
      </span>
      {copied ? (
        <Check className="h-3.5 w-3.5 shrink-0 text-emerald-600" />
      ) : (
        <Copy className="h-3.5 w-3.5 shrink-0 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" />
      )}
    </button>
  )
}
